<div class="card p-px-5" >
    <p-steps [model]="items" [readonly]="true"></p-steps>
</div>
<router-outlet></router-outlet>